<template>
	<router-view />
	<AppFooter />
	<div class="notification-container">
		<Notification 
			v-for="notification in notifications" 
			:key="notification.id" 
			:message="notification.message" 
			:type="notification.type" 
			:closable="notification.closable"
			@remove="handleRemoveNotification(notification.id)"
		/>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useSettings } from './composables/useSettings'
import { useNotifications } from './composables/useNotifications'
import Notification from './components/Notification.vue'

import AppFooter from './components/AppFooter.vue'

const { loadSettings } = useSettings()
const { notifications, removeNotification } = useNotifications()

const handleRemoveNotification = (id: number) => {
  removeNotification(id)
}

onMounted(() => {
  loadSettings()
})
</script>

<style>
.notification-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.notification-container > * {
  pointer-events: auto;
}


#app {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  
}

.fullscreen-page {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.card {
	background-color: var(--content-background-color);
	border: var(--content-border);
	border-radius: 0.5em;
	padding: 1.5rem;
	display: flex;
	flex-direction: column;
	/* gap: 1.25rem; */
	& h2 {
	margin: 0 0 1.5rem;
	font-size: 1.3rem;
	color: #333;
	}

	& h3 {
	margin: 0 0 1rem;
	font-size: 1rem;
	color: #333;
	}

	& p {
	margin: 0.5rem 0;
	color: #666;
	}
}


.btn {
	padding: 0.75rem 1.5rem;
	border: none;
	border-radius: 4px;
	font-size: 1rem;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.2s, transform 0.1s;
	&:hover:not(:disabled) {
		transform: translateY(-0.125em);
	}

	&:active {
		transform: translateY(0);
	}
	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}

.primary.btn {
	background-color: var(--primary-control-background-color);
	color: var(--primary-control-text-color);
	&:hover:not(:disabled) {
		background-color: var(--hovered-primary-control-background-color);
	}

	&:disabled {
		background-color: var(--disabled-control-background-color);
		color: var(--disabled-control-text-color);
		cursor: not-allowed;
	}
}

.secondary.btn {
	background-color: var(--secondary-control-background-color);
	color: var(--secondary-control-text-color);
	flex: 1;
	&:hover:not(:disabled) {
		background-color: var(--hovered-secondary-control-background-color);
		color: var(--hovered-secondary-control-text-color);
	}
}

.success.btn {
	background-color: #28a745;
	color: white;
	&:hover:not(:disabled) {
  		background-color: #218838;
	}
}


.danger.btn {
	background-color: #dc3545;
	color: white;
	&:hover:not(:disabled) {
  		background-color: #c82333;
	}
}

.small.btn {
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
  margin-right: 0.5rem;
}



/* Global styles can remain here if needed */
</style>
